import VueRouter from 'vue-router';
import LoginComponent from './components/Login';
import ResetPasswordComponent from './components/ResetPassword';

import EventReportsPage from './pages/EventReportsPage';

import UserPage from './pages/UserPage';
import DancerPage from './pages/user/DancerPage';
import StarterTemplatePage from './pages/user/StarterTemplatePage';
import UserEventsPage from './pages/user/EventsPage';
import EventRegistrationsPage from './pages/user/EventRegistrationsPage';

import Dashboard from './components/user/Dashboard';
import DancerComponent from './components/user/Dancer';
import EventRegistrationComponent from './components/user/EventRegistration';

import AdminPage from './pages/AdminPage';
import AdminEventsPage from './pages/admin/EventsPage';
import UsersPage from './pages/admin/UsersPage';
import CompleteRegistrationPage from './pages/CompleteRegistrationPage';
import EnvironmentPage from './pages/admin/EnvironmentPage';
import I18nPage from './pages/admin/I18nPage';
import RefundPage from './pages/admin/RefundPage';
import EventRegistrationPage from './pages/admin/EventRegistrationPage';
import StarterRegistrationPage from './pages/admin/StarterRegistrationPage';
import SettingsPage from './pages/user/SettingsPage';
import WelcomePage from './pages/user/WelcomePage';
import ConditionsPage from './pages/ConditionsPage';

import EventComponent from './components/admin/Event';
import EventSchedulesComponent from './components/admin/EventSchedules';

//const RegisterComponent = Vue.component('register', require('./components/Register.vue'));

// 2. Define some routes
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// `Vue.extend()`, or just a component options object.
// We'll talk about nested routes later.
const routes = [
    {
        path: '/admin',
        component: AdminPage,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: 'events',
                component: AdminEventsPage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'events/create',
                component: EventComponent,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'events/:id',
                component: EventComponent,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'event_schedules/:id',
                component: EventSchedulesComponent,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'users',
                component: UsersPage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'environment',
                component: EnvironmentPage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'translations',
                component: I18nPage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'event-registration/:id',
                component: EventRegistrationPage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'starter-registration/:id',
                component: StarterRegistrationPage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'refund',
                component: RefundPage,
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/user',
        component: UserPage,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: 'dashboard',
                component: Dashboard,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'dancer',
                component: DancerPage,
                meta: {
                    requiresAuth: true
                },
            },
            {
                path: 'dancer/create',
                component: DancerComponent,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'dancer/edit/:id',
                component: DancerComponent,
                props: true,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'starter-template',
                component: StarterTemplatePage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'starter-template/create',
                component: StarterTemplatePage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'starter-template/edit/:id',
                component: StarterTemplatePage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'events',
                component: UserEventsPage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'event-registration-list/:id',
                component: EventRegistrationsPage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'event-registration-list',
                component: EventRegistrationsPage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'event-registration',
                component: EventRegistrationComponent,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'event-registration/:id',
                component: EventRegistrationComponent,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'settings',
                component: SettingsPage,
                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'welcome',
                component: WelcomePage,
                meta: {
                    requiresAuth: true
                }
            }
        ]
    },
    {
        path: '/event-reports',
        component: EventReportsPage,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/event-reports/:id',
        component: EventReportsPage,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'login',
        component: LoginComponent,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/register/:userId/:token',
        component: CompleteRegistrationPage,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/reset-password',
        component: ResetPasswordComponent,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/reset-password/:userId/:token',
        component: ResetPasswordComponent,
        meta: {
            requiresAuth: false
        }
    },
    {
        path: '/conditions',
        component: ConditionsPage,
        meta: {
            requiresAuth: false
        }
    }
];

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
export default new VueRouter({
    mode: 'history',
    routes // short for `routes: routes`
});
